import { invert } from 'lodash';

export const ENTITY = {
    TRACKING_SETTINGS: 'TRACKING-SETTINGS',
    CONVERSION: 'CONVERSION',
    GTM_SETUP: 'GTM_SETUP',
    MANUALLY_SETUP: 'MANUALLY_SETUP',
    S2S_SETUP: 'S2S_SETUP',
    SHOPIFY_SETUP: 'SHOPIFY_SETUP',
    WORDPRESS_SETUP: 'WORDPRESS_SETUP',
    TEST_EVENTS: 'TEST_EVENTS',
    ACTIVE_EVENTS: 'ACTIVE_EVENTS',
    FUNNEL: 'FUNNEL',
    CODELESS_EVENT_TOOL: 'CODELESS_EVENT_TOOL',
    SEND_TO_DEV_TEAM: 'SEND_TO_DEV_TEAM',
};

export const ENTITY_TO_PATH_MAP = {
    [ENTITY.TRACKING_SETTINGS]: 'tracking-settings',
    [ENTITY.CONVERSION]: 'conversion',
    [ENTITY.FUNNEL]: 'funnel',
    [ENTITY.GTM_SETUP]: 'gtm-setup',
    [ENTITY.MANUALLY_SETUP]: 'manually-setup',
    [ENTITY.S2S_SETUP]: 'server-to-server-setup',
    [ENTITY.SHOPIFY_SETUP]: 'shopify-setup',
    [ENTITY.WORDPRESS_SETUP]: 'wordpress-setup',
    [ENTITY.TEST_EVENTS]: 'test-events',
    [ENTITY.ACTIVE_EVENTS]: 'active-events',
    [ENTITY.CODELESS_EVENT_TOOL]: 'codeless-event-tool',
    [ENTITY.SEND_TO_DEV_TEAM]: 'send_to_dev_team',
};

export const DETECTED_METHOD_TO_ENTITY = {
    WORDPRESS: ENTITY.WORDPRESS_SETUP,
    SHOPIFY: ENTITY.SHOPIFY_SETUP,
    GTM: ENTITY.GTM_SETUP,
};

export const PATH_TO_ENTITY_MAP = invert(ENTITY_TO_PATH_MAP);
